import { Model } from '@vuex-orm/core';

export default class Buildingable extends Model {
  static entity = 'buildingables';

  static fields() {
    return {
      id: this.uid(),
      building_id: this.attr(null),
      buildingable_id: this.attr(null),
      buildingable_type: this.attr(null),
    };
  }
}
